export function withCache(generate) {
    var cache = null;
    return function () {
        if (cache === null) {
            cache = generate();
        }
        return cache;
    };
}
